module.exports = __webpack_public_path__ + "media/C6.7da8cbde.mp3";